// @ts-nocheck
import React, { useEffect, useState } from "react";
import {
  List,
  Datagrid,
  SimpleForm,
  TopToolbar,
  Edit,
  EditButton,
  required,
  SelectInput,
  TextInput,
  useRecordContext,
  ImageInput,
  ImageField,
  FormDataConsumer,
  useNotify,
  useRedirect,
  useDataProvider,
  Toolbar,
  SaveButton,
  DeleteWithConfirmButton,
} from "react-admin";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import _ from "lodash";
import { useMutation } from "react-query";

const countryList = [
  { id: "GLOBAL", name: "Worldwide" },
  { id: "HK", name: "Hong Kong" },
  { id: "ID", name: "Indonesia" },
  { id: "MY", name: "Malaysia" },
  { id: "TW", name: "Taiwan" },
];

const EditTitle = () => {
  return <span>Diaspora Emergency &gt; Edit</span>;
};

const CustomToolbar = ({ dataForm, initDataForm }: any) => {
  console.log("init", initDataForm);
  console.log("late", dataForm);
  console.log(_.isEqual(dataForm, initDataForm));
  const tempFormData = Object.keys(dataForm).forEach(
    (key) => !dataForm[key] && delete dataForm[key]
  );

  const notify = useNotify();
  const redirect = useRedirect();

  const dataProvider = useDataProvider();
  const { mutate, isLoading, isSuccess } = useMutation(() =>
    dataProvider.update("diasporaEmergency", {
      data: { ...dataForm },
      id: dataForm?.id,
    })
  );
  const [eq, setEq] = useState(true);
  useEffect(() => {
    const equal = _.isEqual(dataForm, initDataForm);
    setEq(equal);
  }, [dataForm]);

  useEffect(() => {
    if (isSuccess) {
      // notify("ra.notification.updated", "info", { smart_count: 1 });
      redirect("/diasporaEmergency");
    }
  }, [isSuccess]);
  return (
    <Toolbar classes={useStyles()}>
      <SaveButton
        onClick={(event) => {
          if (Object.keys(dataForm).length >= 9) {
            event.preventDefault();
            mutate();
          }
        }}
        data-test-id="save_btn"
        disabled={eq}
      />
      <DeleteWithConfirmButton confirmContent="Are you sure want to delete this record?" />
    </Toolbar>
  );
};

const EditPage = (props) => {
  const classes = useStyles();

  const PrevImage = () => {
    const record: any = useRecordContext();
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          marginBlockEnd: 50,
        }}
      >
        <div>
          <span style={{ fontWeight: 300, fontSize: "0.75em" }}>
            Previous Image
          </span>
        </div>
        <div style={{ marginBlockStart: 20 }}>
          <img
            style={{ marginInlineStart: 40 }}
            src={record?.urlThumbnail}
            width={150}
          ></img>
        </div>
      </div>
    );
  };

  const [initDataForm, setInitDataForm] = useState({});
  const [dataForm, setDataForm] = useState({});
  return (
    <Edit title={<EditTitle />} {...props}>
      <SimpleForm
        toolbar={
          <CustomToolbar dataForm={dataForm} initDataForm={initDataForm} />
        }
      >
        <div className={classes.root}>
          <div className={classes.form}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <SelectInput
                  data-test-id="country_select"
                  fullWidth
                  className={classes.input}
                  source="country_code"
                  validate={[required()]}
                  choices={countryList}
                  label="Country"
                />
              </Grid>
              <Grid item xs={6}>
                <TextInput
                  data-test-id="phone_input"
                  fullWidth
                  validate={[required()]}
                  type={"tel"}
                  source="phone"
                  label="Phone Number"
                />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  data-test-id="label_input"
                  fullWidth
                  validate={[required()]}
                  source="label"
                  label="Label"
                />
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <PrevImage />
                <ImageInput
                  source="newUrlThumbnail"
                  label="Thumbnail"
                  accept="image/*"
                  options={{ multiple: false }}
                >
                  <ImageField source="src" title="title" />
                </ImageInput>
              </Grid>
              <Box flex={1} mr="0.5em" display="none">
                <TextInput source="oldThumbnail" label="Line Count" fullWidth />
              </Box>
            </Grid>
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                if (Object.keys(initDataForm).length === 0) {
                  setInitDataForm(formData);
                }
                setDataForm(formData);
              }}
            </FormDataConsumer>
          </div>
        </div>
      </SimpleForm>
    </Edit>
  );
};

export default EditPage;

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
  },
  form: {
    flexGrow: 1,
  },
  input: {
    marginBottom: "-20px ",
  },
  text: {
    color: "#0000008A",
  },
}));
